<template>
  <div class="d-flex flex-column h-100 overflow-y-scroll">
    <TopBar />
    <SideBar :is-open="opened" />
    <router-view v-slot="{ Component, route }">
      <transition
        enter-active-class="animate__animated animate__faster animate__fadeIn"
        leave-active-class="animate__animated animate__faster animate__fadeOut"
        mode="out-in"
      >
        <main :key="route.name" class="flex-shrink-0 ps-md-6 pt-md-6">
          <component :is="Component" />
        </main>
      </transition>
    </router-view>
    <FooterBar />
  </div>
</template>

<script>
import TopBar from './TopBar.vue';
import SideBar from './SideBar.vue';
import FooterBar from './FooterBar.vue';
import eventbus from '@/modules/core/services/eventbus';

export default {
  components: { TopBar, SideBar, FooterBar },
  data: () => ({ opened: false }),
  mounted() { eventbus.on('sidebar.opened', this.onOpenedSidebar); },
  unmounted() { eventbus.off('sidebar.opened', this.onOpenedSidebar); },
  methods: {
    onOpenedSidebar(opened) { this.opened = opened; },
  },
};
</script>

<style scoped>
  @media (min-width: 768px) {
    .ps-md-6 { padding-left: 60px!important; }
  }
  @media (max-width: 767px) {
    .pt-md-6 { padding-top: 4.75rem!important; }
  }
  .overflow-y-scroll { overflow-y:scroll!important; }
  .animate__faster { --animate-duration: 0.5s; }
</style>
